import { render, staticRenderFns } from "./tradInstru.vue?vue&type=template&id=50e37e7c&scoped=true&"
import script from "./tradInstru.vue?vue&type=script&lang=js&"
export * from "./tradInstru.vue?vue&type=script&lang=js&"
import style0 from "./tradInstru.vue?vue&type=style&index=0&id=50e37e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e37e7c",
  null
  
)

export default component.exports